<template>
  <div>
    <Collapse v-model="value" simple style="border:0">
      <Panel name="1" hide-arrow style="margin: 20px 0 0 0;border:0">
        <FormTitle :titleText="$t('Employee_Information')" /><!-- 基本信息 -->
        <Form
          :label-width="100"
          label-position="left"
          slot="content"
          style="margin: 30px 5px 0 5px"
        >
          <Row :gutter="40">
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Name')"
                ><!-- 姓名 -->
                <Input
                  v-model="userinfoItem.userName"
                  :disabled="this.$route.query.id ? true : false"
                  readonly
                  :enter-button="this.$route.query.id ? false : true"
                  :search="this.$route.query.id ? false : true"
                  @on-search="personSearch"
                />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Employee_Code')"
                ><!-- 员工号 -->
                <Input v-model="userinfoItem.empCode" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('BU')"
                ><!-- 业务单元 -->
                <Select
                  v-model="userinfoItem.businessUnit"
                  clearable
                  style="width:100%"
                  disabled
                >
                  <Option
                    v-for="item in businessUnitList"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Position')"
                ><!-- 职位 -->
                <Input v-model="userinfoItem.position" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Line_Manager')"
                ><!-- 直线上级 -->
                <Input v-model="userinfoItem.dirSupUserName" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Department')"
                ><!-- 部门 -->
                <Select
                  v-model="userinfoItem.department"
                  disabled
                  style="width:100%"
                >
                  <Option
                    v-for="item in departmentList"
                    :value="item.code"
                    :key="item.code"
                    >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Year')"
                ><!-- 年度 -->
                <Input v-model="userinfoItem.year" disabled />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Tabs value="name1" :animated="false" @on-click="tabsClick">
        <TabPane :label="$t('Update_Plan')" name="name1"
          ><ImprovementPlan ref="ImprovementPlan"></ImprovementPlan></TabPane
        ><!-- 改进计划 -->
        <TabPane :label="$t('Progress_review')" name="name2"
          ><ProgressReview ref="ProgressReview"></ProgressReview></TabPane
        ><!-- 进度回顾 -->
      </Tabs>
    </Collapse>
    <Modal
      v-model="modal"
      :title="$t('PB_Select_Employee_Search')"
      width="70%"
      :closable="false"
      ><!-- 选择员工 -->
      <Form :model="modalFormItem" :label-width="100">
        <Row :gutter="20">
          <Col :xs="24" :sm="24" :md="12" :lg="8">
            <FormItem :label="$t('Employee_Code')"
              ><!-- 员工号 -->
              <Input type="text" v-model="modalFormItem.empCode" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="8">
            <FormItem :label="$t('Name')"
              ><!-- 姓名 -->
              <Input type="text" v-model="modalFormItem.userName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="2">
            <FormItem style="display: flex;justify-content: end;">
              <Button @click="getData"><!-- 检 索 -->{{ $t("Search") }}</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table highlight-row border :columns="modelColumns" :data="modelData">
        <template slot="action1" slot-scope="{ row, index }">
          <Icon
            size="26"
            color="#006B37"
            type="md-menu"
            @click="onSelect(row, index)"
          />
        </template>
      </Table>
      <div style="display: flex;justify-content: end;margin-top: 30px;">
        <Page :total="total" @on-change="pageChange"></Page>
      </div>
      <div slot="footer">
        <Button type="text" @click="modal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import ProgressReview from "./components/MyAchievementsComponents/ProgressReview"; //进度回顾
import ImprovementPlan from "./components/MyAchievementsComponents/ImprovementPlan"; //改进计划
import axios from "axios";
export default {
  components: { ProgressReview, ImprovementPlan },
  data() {
    return {
      value: [1],
      modalFormItem: {},
      userinfoItem: {},
      modelData: [],
      modal: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      businessUnitList: [],
      departmentList: []
    };
  },
  computed: {
    modelColumns() {
      return [
        {
          title: this.$t("Select_Dev") /* 选择 */,
          slot: "action1",
          align: "center",
          minWidth: 70
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "eName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_English") /* 职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 200
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    // console.log(JSON.parse( this.$route.query.item))
    if (this.$route.query.id) {
      this.$refs.ImprovementPlan.id = this.$route.query.id;
      this.$refs.ProgressReview.id = this.$route.query.id;
      this.$refs.ImprovementPlan.isDirSup = this.$route.query.isDirSup;
      this.$refs.ProgressReview.isDirSup = this.$route.query.isDirSup;
      this.$refs.ImprovementPlan.getData(JSON.parse(this.$route.query.item));
      this.$refs.ProgressReview.getData(JSON.parse(this.$route.query.item));
      this.userinfoItem = JSON.parse(this.$route.query.item);
    } else if (this.$route.query.isDirSup) {
      this.$refs.ImprovementPlan.isDirSup = this.$route.query.isDirSup;
      this.$refs.ProgressReview.isDirSup = this.$route.query.isDirSup;
      this.getData();
    } else {
      this.getData();
    }
    this.getListData();
  },
  methods: {
    tabsClick(val) {
      if (val == "name1") {
        if (this.$route.query.id) {
          this.$refs.ImprovementPlan.getData(
            JSON.parse(this.$route.query.item)
          );
        } else {
          this.getData();
        }
      } else {
        this.$refs.ProgressReview.getData(this.$refs.ImprovementPlan.item);
        this.$refs.ProgressReview.id = this.$refs.ImprovementPlan.id;
      }
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
        }
      });
    },
    getData() {
      axios
        .post("/achUpdatePlan/selectAchUpdatePlanEmpInfo", {
          ...this.modalFormItem,
          ...this.pageInfo
        })
        .then(res => {
          this.modelData = res.data;
          this.total = parseInt(res.pageInfo.total);
        });
    },
    personSearch() {
      this.modal = true;
    },
    onSelect(item, index) {
      this.modal = false;
      this.userinfoItem = item;
      this.$refs.ImprovementPlan.getData(item);
      this.$refs.ProgressReview.getData(item);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchImprovement.vue